/* RÆV — Support phone composer */
(() => {
  'use strict';

  const FLAG_BY_CODE = {
    '+351': '🇵🇹',
    '+43': '🇦🇹',
    '+32': '🇧🇪',
    '+359': '🇧🇬',
    '+385': '🇭🇷',
    '+357': '🇨🇾',
    '+420': '🇨🇿',
    '+45': '🇩🇰',
    '+372': '🇪🇪',
    '+358': '🇫🇮',
    '+33': '🇫🇷',
    '+49': '🇩🇪',
    '+30': '🇬🇷',
    '+36': '🇭🇺',
    '+353': '🇮🇪',
    '+39': '🇮🇹',
    '+371': '🇱🇻',
    '+370': '🇱🇹',
    '+352': '🇱🇺',
    '+356': '🇲🇹',
    '+31': '🇳🇱',
    '+48': '🇵🇱',
    '+40': '🇷🇴',
    '+421': '🇸🇰',
    '+386': '🇸🇮',
    '+34': '🇪🇸',
    '+46': '🇸🇪'
  };

  const normalizeNationalNumber = (rawValue, dialCode) => {
    let value = String(rawValue || '').trim();
    if (!value) return '';

    const escapedCode = dialCode.replace('+', '\\+');
    value = value.replace(
      new RegExp(`^(?:${escapedCode}|00${dialCode.slice(1)})\\s*`),
      ''
    );

    return value.replace(/[^\d]/g, '');
  };

  const initializePhoneFields = (root = document) => {
    root.querySelectorAll('.contact-form__phone-code').forEach((codeSelect) => {
      if (codeSelect.dataset.raevPhoneReady === 'true') return;

      const row = codeSelect.closest('.contact-form__phone-row');
      const form = codeSelect.closest('form');
      const phoneInput = row?.querySelector(
        '#ContactForm-phone, input[type="tel"][name="contact[phone]"]'
      );

      if (!row || !form || !phoneInput) return;

      codeSelect.dataset.raevPhoneReady = 'true';

      Array.from(codeSelect.options).forEach((option) => {
        const countryName = option.textContent
          .replace(/\s*\([^)]*\)\s*$/, '')
          .trim();
        const flag = FLAG_BY_CODE[option.value] || '🌐';
        const compactLabel = `${flag} ${option.value}`;

        option.dataset.countryName = countryName;
        option.textContent = compactLabel;
        option.label = compactLabel;
        option.title = `${countryName} (${option.value})`;
      });

      const updateSelectTitle = () => {
        const selected = codeSelect.selectedOptions[0];
        if (selected) codeSelect.title = selected.title || selected.textContent;
      };

      updateSelectTitle();
      codeSelect.addEventListener('change', updateSelectTitle);

      let completePhone = form.querySelector('input[data-raev-complete-phone]');
      if (!completePhone) {
        completePhone = document.createElement('input');
        completePhone.type = 'hidden';
        completePhone.dataset.raevCompletePhone = 'true';
        form.appendChild(completePhone);
      }

      form.addEventListener(
        'submit',
        () => {
          const dialCode = codeSelect.value;
          const nationalNumber = normalizeNationalNumber(phoneInput.value, dialCode);

          if (nationalNumber) {
            completePhone.name = 'contact[phone]';
            completePhone.value = `${dialCode} ${nationalNumber}`;
            phoneInput.removeAttribute('name');
            codeSelect.removeAttribute('name');
          } else {
            completePhone.removeAttribute('name');
            completePhone.value = '';
            phoneInput.name = 'contact[phone]';
            codeSelect.name = 'contact[Prefijo internacional]';
          }
        },
        { capture: true }
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializePhoneFields());
  } else {
    initializePhoneFields();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializePhoneFields(event.target);
  });
})();
